import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Alias } from '@app/store/setting/setting.state';

@Component({
  selector: 'app-alias-list',
  templateUrl: './alias-list.component.html'
})
export class AliasListComponent implements OnInit {
  @Input() aliasList: Alias[] = [];
  @Input() control!: FormControl;

  isChecked(itemAlias: Alias): boolean {
    const findIdAlias = this.aliasList?.findIndex((f) => f.checked === true);
    if (findIdAlias === -1 && itemAlias?.id == '') {
      return true;
    } else if (
      findIdAlias !== -1 &&
      itemAlias?.id === this.aliasList[findIdAlias]?.id
    ) {
      return true;
    }
    return false;
  }

  constructor() {}

  ngOnInit(): void {}
}
